import React from 'react'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Link } from "react-router-dom";
import BookIcon from '@material-ui/icons/Book';
import PantryIcon from '@material-ui/icons/Fastfood';
import GroupIcon from '@material-ui/icons/Group';


export default function NavBar({ match }) {
    return (
        <div className="NavBar">
            <Tabs
                variant="fullWidth"
                indicatorColor="primary"
                textColor="primary"
            >
                <Tab component={Link} to={`${match.url}/recipes`} icon={<BookIcon />} label="Recipes" aria-label="Recipes" />
                <Tab component={Link} to={`${match.url}/pantry`} icon={<PantryIcon />} label="Pantry" aria-label="Pantry" />
                <Tab component={Link} to={`${match.url}/socialfeed`} icon={<GroupIcon />} label="Social Feed" aria-label="Person" />
            </Tabs>
        </div>
    )
}
